
import { getButtonType } from "../utils/helpers";
export default {
  name: "Button",
  props: {
    type: {
      type: String,
      default: "primary",
    },
    text: {
      type: String,
      default: "click me"
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'url'
    },
    destiny: {
      type: String,
      default: ''
    }
  },
  computed: {
    btnType() {
      const color = getButtonType(this.type);
      return color;
    },
  },
  methods: {
    actionButton () {
      if (this.destiny !== '') {
        this.$router.push(this.destiny)
      }
    }
  }
};
